module.exports = __webpack_public_path__ + "img/reservas-clasificacion.4a0c88f4.png";